import { ResizeObserverContainer } from 'components/ResizeObserverContainer/ResizeObserverContainer';
import { getPieVendorChart } from 'containers/Chartjs';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { equals } from 'ramda';
import { Component } from 'react';

export default class NetworkVendorMix extends Component {
  static propTypes = {
    Chart: PropTypes.any.isRequired,
    data: PropTypes.shape({
      hostVendorMix: PropTypes.object,
    }),
    msg: PropTypes.object.isRequired,
  };

  state = {
    width: null,
  };

  componentDidMount() {
    this.drawGraph();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !equals(nextProps.data.hostVendorMix, this.props.data.hostVendorMix) ||
      this.state.width !== nextState.width
    );
  }

  getSnapshotBeforeUpdate(_prevProps, prevState) {
    if (this.state.width !== prevState.width && this.pieVendorChart) {
      this.pieVendorChart.destroy();
      return true;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !equals(prevProps.data.hostVendorMix, this.props.data.hostVendorMix) &&
      this.pieVendorChart
    ) {
      this.pieVendorChart.destroy();
    }
    if (this.state.width !== prevState.width) {
      this.drawGraph(false);
    } else {
      this.drawGraph();
    }
  }

  componentWillUnmount() {
    if (this.pieVendorChart) {
      this.pieVendorChart.destroy();
    }
  }

  drawGraph = (animationEnabled = true) => {
    const {
      msg,
      Chart,
      data: { hostVendorMix },
    } = this.props;
    if (this.hostVendorMix) {
      this.pieVendorChart = getPieVendorChart(
        Chart,
        this.hostVendorMix,
        msg.hostVendorMix,
        animationEnabled,
        hostVendorMix.labels,
        hostVendorMix.data,
      );
    }
  };

  handleResize = (element) => {
    const PADDING = 30;

    this.setState({
      width: element.clientWidth - PADDING,
    });
  };

  render() {
    const {
      msg,
      data: { hostVendorMix },
    } = this.props;
    const data = get(hostVendorMix, 'data');
    const width = this.state.width <= 400 ? this.state.width : '400';

    if (!data || !data.length) {
      return (
        <div>
          <h4 className='dashboard-vendor-mix__title'>
            {get(msg, 'hostVendorMix')}
          </h4>
          <p>{get(msg, 'noDataAvailable')}</p>
        </div>
      );
    }

    return (
      <div className='row'>
        <ResizeObserverContainer
          className='col-xs-12'
          onResize={this.handleResize}
        >
          <canvas
            className='center-block'
            height='400'
            ref={(c) => {
              this.hostVendorMix = c;
            }}
            width={width}
          />
        </ResizeObserverContainer>
      </div>
    );
  }
}
